import { criarCatalogoFiltros } from '@/utils/catalogoFiltros';

/**
 * Catálogo de filtros da tela de Acompanhamento.
 *
 * Fonte única: o painel monta os campos a partir daqui, a barra de chips descreve o que está ativo
 * lendo daqui, e o getParams monta a query string daqui. Adicionar um filtro é acrescentar uma
 * entrada nesta lista (e o `where` correspondente no AcompanhamentoController).
 *
 * `param` é o nome do parâmetro na API quando difere da chave interna.
 *
 * Pedidos, faturamento e entregador saem das métricas coletadas de madrugada (valem até ontem).
 * Con. WhatsApp não tem filtro: o status vem de uma chamada HTTP por empresa, feita só para as
 * linhas da página.
 */

const STATUS_ONBOARDING = [
    { value: 'pendente', text: 'Pendente' },
    { value: 'aguardando', text: 'Aguardando' },
    { value: 'impressora_indicada', text: 'Impressora Indicada' },
    { value: 'agendado', text: 'Agendado' },
    { value: 'concluido', text: 'Concluído' },
    { value: '__NULL__', text: 'Não definido' },
];

export const CAMPOS = [
    {
        chave: 'status',
        param: 'filters',
        titulo: 'Status',
        grupo: 'Situação',
        tipo: 'multi',
        cols: 12,
        dica: 'Marcar mais de um soma os grupos.',
        opcoes: [
            { value: 'ativos', text: 'Ativos' },
            { value: 'inadimplentes', text: 'Inadimpl.' },
            { value: 'assinantes', text: 'Assinantes' },
            { value: 'sem_assinatura', text: 'Sem assinatura' },
        ],
    },
    {
        chave: 'implementacao',
        titulo: 'Criação',
        grupo: 'Onboarding',
        tipo: 'multi',
        cols: 4,
        opcoes: STATUS_ONBOARDING,
    },
    {
        chave: 'configuracao_impressora',
        titulo: 'Config. Impressora',
        grupo: 'Onboarding',
        tipo: 'multi',
        cols: 4,
        opcoes: STATUS_ONBOARDING,
    },
    {
        chave: 'configuracao_taxa_entrega',
        titulo: 'Config. Taxa de Entrega',
        grupo: 'Onboarding',
        tipo: 'multi',
        cols: 4,
        opcoes: STATUS_ONBOARDING,
    },
    {
        chave: 'impressora',
        titulo: 'Tem impressora?',
        grupo: 'Onboarding',
        tipo: 'multi',
        cols: 6,
        opcoes: [
            { value: 'sim', text: 'Sim' },
            { value: 'nao', text: 'Não' },
            { value: 'aguardando_chegar', text: 'Aguardando chegar' },
            { value: '__NULL__', text: 'Não definido' },
        ],
    },
    {
        chave: 'tipo_taxa_entrega',
        titulo: 'Tipo de Taxa de Entrega',
        grupo: 'Onboarding',
        tipo: 'multi',
        cols: 6,
        opcoes: [
            { value: 'bairro', text: 'Por bairro' },
            { value: 'distancia', text: 'Por distância' },
            { value: 'fixa', text: 'Fixa' },
            { value: 'sem_taxa', text: 'Sem taxa' },
            { value: 'sem_delivery', text: 'Sem delivery' },
            { value: '__NULL__', text: 'Não definido' },
        ],
    },
    {
        chave: 'entregador',
        titulo: 'Entregador cadastrado',
        grupo: 'Onboarding',
        tipo: 'multi',
        cols: 12,
        opcoes: [
            { value: 'sim', text: 'Sim' },
            { value: 'nao', text: 'Não' },
        ],
    },
    {
        chave: 'chave_pix',
        titulo: 'Pix Cadastrado',
        grupo: 'Pagamento',
        tipo: 'multi',
        cols: 6,
        dica: 'Chave Pix informada manualmente pelo lojista.',
        opcoes: [
            { value: 'sim', text: 'Cadastrado' },
            { value: 'nao', text: 'Não cadastrado' },
        ],
    },
    {
        chave: 'pix_automatizado',
        titulo: 'PIX Automatizado',
        grupo: 'Pagamento',
        tipo: 'multi',
        cols: 6,
        dica: 'Conta Mercado Pago conectada via OAuth.',
        opcoes: [
            { value: 'conectado', text: 'Conectado' },
            { value: 'nao_conectado', text: 'Não conectado' },
        ],
    },
    {
        chave: 'pedidos_7d_min',
        titulo: 'Pedidos 7 dias, de',
        grupo: 'Vendas',
        tipo: 'numero',
        cols: 6,
    },
    {
        chave: 'pedidos_7d_max',
        titulo: 'Pedidos 7 dias, até',
        grupo: 'Vendas',
        tipo: 'numero',
        cols: 6,
        dica: 'Até 0 mostra quem não vendeu na semana.',
    },
    {
        chave: 'faturamento_30d_min',
        titulo: 'Faturamento 30 dias, de',
        grupo: 'Vendas',
        tipo: 'numero',
        cols: 6,
        prefixo: 'R$',
    },
    {
        chave: 'faturamento_30d_max',
        titulo: 'Faturamento 30 dias, até',
        grupo: 'Vendas',
        tipo: 'numero',
        cols: 6,
        prefixo: 'R$',
    },
    {
        chave: 'dispositivos',
        titulo: 'Dispositivos',
        grupo: 'Outros',
        tipo: 'multi',
        cols: 6,
        opcoes: [
            { value: 'pc', text: 'PC' },
            { value: 'mobile', text: 'Celular' },
            { value: 'nenhum', text: 'Nenhum' },
        ],
    },
    {
        chave: 'observacoes',
        titulo: 'Observações',
        grupo: 'Outros',
        tipo: 'multi',
        cols: 6,
        opcoes: [
            { value: 'com', text: 'Com observações' },
            { value: 'sem', text: 'Sem observações' },
        ],
    },
    {
        chave: 'sem_pedido_dias',
        titulo: 'Sem pedido há mais de',
        grupo: 'Outros',
        tipo: 'numero',
        cols: 4,
        sufixo: 'dias',
        dica: 'Inclui quem nunca vendeu.',
    },
    {
        chave: 'ultimo_pedido_de',
        titulo: 'Últ. pedido de',
        grupo: 'Outros',
        tipo: 'data',
        cols: 4,
    },
    {
        chave: 'ultimo_pedido_ate',
        titulo: 'Últ. pedido até',
        grupo: 'Outros',
        tipo: 'data',
        cols: 4,
    },
];

const catalogo = criarCatalogoFiltros(CAMPOS);

export const {
    GRUPOS,
    camposDoGrupo,
    rotulo,
    filtrosPadrao,
    normalizarFiltros,
    totalAtivos,
    chipsAtivos,
    aplicarParams,
} = catalogo;

export default catalogo;
